module.exports = __webpack_public_path__ + "static/media/fr.cbbe8a6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/fr.svg
// module id = 1446
// module chunks = 0